import { useDispatch, useSelector } from 'react-redux';
import { useState, memo, useEffect, useMemo } from 'react';
import clsx from 'clsx';
import {
    Tabs, Tab, Box, Button, Typography,
    Grid
} from '@material-ui/core'
import { useTranslation } from 'react-i18next';
import 'moment/locale/he'
import {
    fetchGroupSelection,
    fetchGroupsByIds,
    makeFetchGroupsPage,
} from '../../../helpers/Groups/pagedGroups';
import { PagedGroupsFilter } from '../../../hooks/useServerPagedGroups';
import Groups from '../../../components/Groups/GroupsHandler/Groups';
import { TabContext, TabPanel } from '@material-ui/lab';
import { Loader } from '../../../components/Loader/Loader';
import { ActivityEvent, MyActivities, ActivtyTimeInterval, CondType, CondGroup, DynamicGroupModel } from '../../../Models/Groups/DynamicGroup';
import PersonalDetails from './Tabs/PersonalDetails';
import EventsDetails from './Tabs/EventsDetails';
import DateDetails from './Tabs/DateDetails';
import ActivityDetails from './Tabs/ActivityDetails';
import LoyaltyDetails from './Tabs/LoyaltyDetails';
import { getById, save } from '../../../redux/reducers/DynamicGroupsSlice';
import { useParams, useNavigate } from 'react-router-dom';
import useRedirect from '../../../helpers/Routes/Redirect';
import { sitePrefix } from '../../../config';
import { BiSave } from 'react-icons/bi';
import { MdArrowBackIos, MdArrowForwardIos } from 'react-icons/md';
import UpdateGroup from './Tabs/UpdateGroup';
import { Group } from '../../../Models/Groups/Group';
import { logout } from '../../../helpers/Api/PulseemReactAPI';
import Toast from '../../../components/Toast/Toast.component';
import { Title } from '../../../components/managment/Title';
import DefaultScreen from '../../DefaultScreen';
import { GiExitDoor } from 'react-icons/gi';
import { M_AllCampaignChannelds } from '../../../Models/Common/CampaignTypes';
import { DateFormats, TierFeatures } from '../../../helpers/Constants';
import TierPlans from '../../../components/TierPlans/TierPlans';
import { findPlanByFeatureCode } from '../../../redux/reducers/TiersSlice';
import { BaseDialog } from '../../../components/DialogTemplates/BaseDialog';
import { get } from 'lodash';

const EditDynamicGroup = ({ classes }: any) => {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const Redirect = useRedirect();
    const { testGroups } = useSelector((state: any) => state.sms);
    // PR-3790: the picker pages its own rows instead of receiving the whole list.
    const fetchGroupsPage = useMemo(() => makeFetchGroupsPage(dispatch), [dispatch]);
    const { subAccount, isYotpoConnected } = useSelector((state: any) => state.common);
    const [toastMessage, setToastMessage] = useState(null);
    const [showLoader, setLoader] = useState(true);
    const [showTierPlans, setShowTierPlans] = useState(false);
    const [TierMessageCode, setTierMessageCode] = useState('');
    const [dialogType, setDialogType] = useState<string | null>(null);
    const { currentPlan, availablePlans } = useSelector((state: any) => state.tiers);
    const [dynamicGroupModel, setDynamicGroupModel] = useState<any>({
        Group: {
            CreationDate: null,
            DynamicData: '',
            DynamicLastUpdate: null,
            DynamicUpdatePolicy: 0,
            GroupID: 0,
            GroupName: '',
            IsDynamic: true,
            IsTestGroup: false,
            Recipients: 0,
            // SubAccountID: -1,
            UpdateDate: null
        },
        dynamicData: {
            MyActivities: {
                IsNotOpened: null,
                IsNotOpenedFromDate: null,
                IsNotOpenedInterval: ActivtyTimeInterval.Last2Weeks,
                IsNotOpenedToDate: null,

                IsOpened: null,
                IsOpenedFromDate: null,
                IsOpenedInterval: ActivtyTimeInterval.Last2Weeks,
                IsOpenedToDate: null,

                IsClicked: null,
                IsClickedFromDate: null,
                IsClickedInterval: ActivtyTimeInterval.Last2Weeks,
                IsClickedToDate: null,
                IsClickInCampaignTypes: M_AllCampaignChannelds.join(','),

                IsNotClicked: null,
                IsNotClickedFromDate: null,
                IsNotClickedInterval: ActivtyTimeInterval.Last2Weeks,
                IsNotClickedToDate: null,
                IsNotClickInCampaignTypes: M_AllCampaignChannelds.join(','),

                IsPurchased: null,
                IsPurchasedComparingType: ActivityEvent.Any,
                IsPurchasedInterval: ActivtyTimeInterval.Last2Weeks,
                IsPurchasedMinPrice: null,
                IsPurchasedMaxPrice: null,
                IsPurchasedFromDate: null,
                IsPurchasedToDate: null,
                PurchasedPrice: null,

                IsNotPurchased: null,
                IsNotPurchasedComparingType: ActivityEvent.Any,
                IsNotPurchasedInterval: ActivtyTimeInterval.Last2Weeks,
                IsNotPurchasedMinPrice: null,
                IsNotPurchasedMaxPrice: null,
                IsNotPurchasedFromDate: null,
                IsNotPurchasedToDate: null,
                NotPurchasedPrice: null,

                IsAbandoned: null,
                IsAbandonedComparingType: ActivityEvent.Any,
                IsAbandonedInterval: ActivtyTimeInterval.Last2Weeks,
                IsAbandonedMinPrice: null,
                IsAbandonedMaxPrice: null,
                IsAbandonedFromDate: null,
                IsAbandonedToDate: null,
                AbandonedPrice: null,

                IsPageViewed: null,
                IsPageViewedInterval: ActivtyTimeInterval.Last2Weeks,
                IsPageViewedFromDate: null,
                IsPageViewedToDate: null,
                PageViewedPrice: null,
                PageViewedUrlIDs: null,

                ProductCategory: null
            } as MyActivities,
            MyConditions: [{
                FirstName: '',
                FirstNameCond: CondType.Undefined,
                LastName: '',
                LastNameCond: CondType.Undefined,
                Email: '',
                EmailCond: CondType.Undefined,
                Cellphone: '',
                CellphoneCond: CondType.Undefined,
                City: '',
                CityCond: CondType.Undefined,
                Country: '',
                CountryCond: CondType.Undefined,
                Company: '',
                ComapnyCond: CondType.Undefined,
                State: '',
                StateCond: CondType.Undefined,
                BirthDateFrom: null,
                BirthDateTo: null,
                BirthDateFromWithoutYear: null,
                BirthDateToWithoutYear: null,
                ReminderFrom: null,
                ReminderTo: null,
                CreatedFrom: null,
                CreatedTo: null,
                Status: 1, // Active
                StatusCond: CondType.Undefined,
                SmsStatus: 0, // Active
                SmsStatusCond: CondType.Undefined,
                ExtraField1: '',
                ExtraField1Cond: CondType.Undefined,
                ExtraField2: '',
                ExtraField2Cond: CondType.Undefined,
                ExtraField3: '',
                ExtraField3Cond: CondType.Undefined,
                ExtraField4: '',
                ExtraField4Cond: CondType.Undefined,
                ExtraField5: '',
                ExtraField5Cond: CondType.Undefined,
                ExtraField6: '',
                ExtraField6Cond: CondType.Undefined,
                ExtraField7: '',
                ExtraField7Cond: CondType.Undefined,
                ExtraField8: '',
                ExtraField8Cond: CondType.Undefined,
                ExtraField9: '',
                ExtraField9Cond: CondType.Undefined,
                ExtraField10: '',
                ExtraField10Cond: CondType.Undefined,
                ExtraField11: '',
                ExtraField11Cond: CondType.Undefined,
                ExtraField12: '',
                ExtraField12Cond: CondType.Undefined,
                ExtraField13: '',
                ExtraField13Cond: CondType.Undefined,
                ExtraDate1From: null,
                ExtraDate1To: null,
                ExtraDate2From: null,
                ExtraDate2To: null,
                ExtraDate3From: null,
                ExtraDate3To: null,
                ExtraDate4From: null,
                ExtraDate4To: null
            }] as CondGroup[],
            MyGroups: [] as number[],
        } as DynamicGroupModel
    });
    const [tabValue, setTabValue] = useState('0');
    const [selectedGroups, setSelectedGroups] = useState<any>([]);
    const [allGroupsSelected, setAllGroupsSelected] = useState(false);
    const [showTestGroups, setShowTestGroups] = useState(false);
    const [pageState, setPageState] = useState<any | never>(null);
    const { id } = useParams();
    const { isRTL } = useSelector((state: any) => state.core);

    const renderToast = () => {
        setTimeout(() => {
            setToastMessage(null);
        }, 5000);
        return <Toast customData={toastMessage} data={null} />;
    };

    const onSave = async (isExit: boolean | never = false) => {
        let isValid = true;
        let message = '';

        if (dynamicGroupModel.dynamicData.MyActivities.IsPurchased === true) {
            switch (dynamicGroupModel.dynamicData.MyActivities?.IsPurchasedComparingType.toString()) {
                case ActivityEvent.Range: {
                    if ((dynamicGroupModel.dynamicData.MyActivities.IsPurchasedMinPrice === null ||
                        dynamicGroupModel.dynamicData.MyActivities.IsPurchasedMaxPrice === null) ||
                        (parseInt(dynamicGroupModel.dynamicData.MyActivities.IsPurchasedMinPrice) > parseInt(dynamicGroupModel.dynamicData.MyActivities.IsPurchasedMaxPrice))) {
                        isValid = false;
                    }
                    break;
                }
                case ActivityEvent.MoreThan:
                case ActivityEvent.LessThan: {
                    if (dynamicGroupModel.dynamicData.MyActivities.PurchasedPrice === null) {
                        isValid = false;
                    }
                    break;
                }
            }
        }
        if (dynamicGroupModel.dynamicData.MyActivities.IsNotPurchased === true) {
            switch (dynamicGroupModel.dynamicData.MyActivities?.IsNotPurchasedComparingType.toString()) {
                case ActivityEvent.Range: {
                    if ((dynamicGroupModel.dynamicData.MyActivities.IsNotPurchasedMinPrice === null ||
                        dynamicGroupModel.dynamicData.MyActivities.IsNotPurchasedMaxPrice === null) ||
                        (parseInt(dynamicGroupModel.dynamicData.MyActivities.IsNotPurchasedMinPrice) > parseInt(dynamicGroupModel.dynamicData.MyActivities.IsNotPurchasedMaxPrice))) {
                        isValid = false;
                    }
                    break;
                }
                case ActivityEvent.MoreThan:
                case ActivityEvent.LessThan: {
                    if (dynamicGroupModel.dynamicData.MyActivities.NotPurchasedPrice === null) {
                        isValid = false;
                    }
                    break;
                }
            }
        }
        if (dynamicGroupModel.dynamicData.MyActivities.IsAbandoned === true) {
            switch (dynamicGroupModel.dynamicData.MyActivities?.IsAbandonedComparingType.toString()) {
                case ActivityEvent.Range: {
                    if ((dynamicGroupModel.dynamicData.MyActivities.IsAbandonedMinPrice === null ||
                        dynamicGroupModel.dynamicData.MyActivities.IsAbandonedMaxPrice === null) ||
                        (parseInt(dynamicGroupModel.dynamicData.MyActivities.IsAbandonedMinPrice) > parseInt(dynamicGroupModel.dynamicData.MyActivities.IsAbandonedMaxPrice))) {
                        isValid = false;
                    }
                    break;
                }
                case ActivityEvent.MoreThan:
                case ActivityEvent.LessThan: {
                    if (dynamicGroupModel.dynamicData.MyActivities.AbandonedPrice === null) {
                        isValid = false;
                    }
                    break;
                }
            }
        }
        if (isValid &&
            dynamicGroupModel.dynamicData.MyActivities.IsPurchased === true &&
            dynamicGroupModel.dynamicData.MyActivities.IsNotPurchased === true
        ) {
            const pInterval = dynamicGroupModel.dynamicData.MyActivities.IsPurchasedInterval?.toString();
            const npInterval = dynamicGroupModel.dynamicData.MyActivities.IsNotPurchasedInterval?.toString();
            if (pInterval === npInterval) {
                let durationMatch = true;
                if (pInterval === ActivtyTimeInterval.DaysBack) {
                    const pDays = dynamicGroupModel.dynamicData.MyActivities.IsPurchasedDaysBack;
                    const npDays = dynamicGroupModel.dynamicData.MyActivities.IsNotPurchasedDaysBack;
                    durationMatch =
                        !!pDays && !!npDays &&
                        String(pDays) === String(npDays);
                } else if (pInterval === ActivtyTimeInterval.SpecificDates) {
                    durationMatch =
                        dynamicGroupModel.dynamicData.MyActivities.IsPurchasedFromDate ===
                            dynamicGroupModel.dynamicData.MyActivities.IsNotPurchasedFromDate &&
                        dynamicGroupModel.dynamicData.MyActivities.IsPurchasedToDate ===
                            dynamicGroupModel.dynamicData.MyActivities.IsNotPurchasedToDate;
                }
                if (durationMatch) {
                    message = t('group.saveDynamicGroupResponse.events_conflict_purchased_validation');
                    isValid = false;
                }
            }
        }
        if (dynamicGroupModel.dynamicData.MyActivities.IsClicked === true) {

            if (!dynamicGroupModel.dynamicData.MyActivities.IsClickInCampaignTypes) {
                message = t('group.saveDynamicGroupResponse.clickChannelRequired');
                isValid = false;
            }
            else if (dynamicGroupModel.dynamicData.MyActivities.IsClickedInterval.toString() === ActivtyTimeInterval.SpecificDates
                && (!dynamicGroupModel.dynamicData.MyActivities.IsClickedFromDate || !dynamicGroupModel.dynamicData.MyActivities.IsClickedToDate)) {
                message = t('group.saveDynamicGroupResponse.specificDateIsRequired');
                isValid = false;
            }
            else if (dynamicGroupModel.dynamicData.MyActivities.IsClickedInterval.toString() === ActivtyTimeInterval.DaysBack
                && (!dynamicGroupModel.dynamicData.MyActivities.IsClickedDaysBack ||
                    dynamicGroupModel.dynamicData.MyActivities.IsClickedDaysBack === '')) {
                message = t('group.saveDynamicGroupResponse.daysBackError');
                isValid = false;
            }
        }
        if (dynamicGroupModel.dynamicData.MyActivities.IsNotClicked === true) {
            if (!dynamicGroupModel.dynamicData.MyActivities.IsNotClickInCampaignTypes) {
                message = t('group.saveDynamicGroupResponse.notClickChannelRequired');
                isValid = false;
            }
            else if (dynamicGroupModel.dynamicData.MyActivities.IsNotClickedInterval.toString() === ActivtyTimeInterval.SpecificDates
                && (!dynamicGroupModel.dynamicData.MyActivities.IsNotClickedFromDate && !dynamicGroupModel.dynamicData.MyActivities.IsNotClickedToDate)) {
                message = t('group.saveDynamicGroupResponse.specificDateIsRequired');
                isValid = false;
            }
            else if (dynamicGroupModel.dynamicData.MyActivities.IsNotClickedInterval.toString() === ActivtyTimeInterval.DaysBack
                && (!dynamicGroupModel.dynamicData.MyActivities.IsNotClickedDaysBack ||
                    dynamicGroupModel.dynamicData.MyActivities.IsNotClickedDaysBack === '')) {
                message = t('group.saveDynamicGroupResponse.daysBackError');
                isValid = false;
            }
        }
        if (dynamicGroupModel.dynamicData.MyActivities.IsPageViewed === true) {
            if (dynamicGroupModel.dynamicData.MyActivities.IsPageViewedInterval.toString() === ActivtyTimeInterval.SpecificDates
                && (!dynamicGroupModel.dynamicData.MyActivities.IsPageViewedFromDate && !dynamicGroupModel.dynamicData.MyActivities.IsPageViewedToDate)) {
                message = t('group.saveDynamicGroupResponse.specificDateIsRequired');
                isValid = false;
            }
            else if (dynamicGroupModel.dynamicData.MyActivities.IsPageViewedInterval.toString() === ActivtyTimeInterval.DaysBack
                && (!dynamicGroupModel.dynamicData.MyActivities.IsPageViewedDaysBack ||
                    dynamicGroupModel.dynamicData.MyActivities.IsPageViewedDaysBack === '')) {
                message = t('group.saveDynamicGroupResponse.daysBackError');
                isValid = false;
            }
            else if ((dynamicGroupModel.dynamicData.MyActivities.PageViewedMatchType || 'exact') === 'contains') {
                if (!dynamicGroupModel.dynamicData.MyActivities.PageViewedContainsText?.trim()) {
                    message = t('common.field_required');
                    isValid = false;
                }
            }
            else if (!dynamicGroupModel.dynamicData.MyActivities.PageViewedUrlIDs) {
                message = t('group.saveDynamicGroupResponse.pageUrlRequired');
                isValid = false;
            }
        }

        if (isValid) {
            setLoader(true);
            const activities = dynamicGroupModel?.dynamicData?.MyActivities;
            const effectiveMatchType = activities?.PageViewedMatchType || 'exact';
            const cleanActivities = activities?.IsPageViewed
                ? {
                    ...activities,
                    ...(effectiveMatchType === 'contains'
                        ? { PageViewedUrlIDs: null }
                        : { PageViewedContainsText: undefined }
                    )
                }
                : activities;
            var requestObject = {
                Group: dynamicGroupModel?.Group,
                DynamicData: { ...dynamicGroupModel?.dynamicData, MyActivities: cleanActivities }
            } as any;
            const response = await dispatch(save(requestObject));
            handleResponse(response.payload, isExit);
        }
        else {
            showErrorToast(t(message !== '' ? message : 'group.saveDynamicGroupResponse.incorrectValue'));
        }
    }

    const showErrorToast = (message: string) => setToastMessage({ severity: 'error', color: 'error', message, showAnimtionCheck: false } as any)

    const handleGetPlanForFeature = (tierMessageCode: string) => {
        const planName = findPlanByFeatureCode(
            tierMessageCode,
            availablePlans,
            currentPlan.Id
        );
        if (planName) {
            // Fix: Add type assertion to allow string index on TierFeatures
            return t('billing.tier.featureNotAvailable')
                .replace(
                    '{feature}',
                    t((TierFeatures as Record<string, string>)[tierMessageCode] || tierMessageCode)
                )
                .replace('{planName}', planName);
        } else {
            return t('billing.tier.noFeatureAvailable');
        }
    };

    const handleResponse = async (response: any, isExit: boolean = false) => {
        switch (response.StatusCode) {
            case 201: {
                await getData(true);
                if (isExit) {
                    // setLoader(false);
                    setTimeout(() => {
                        onBack();
                    }, 1500);
                }
                break;
            }
            case 400: { // Group does not updated due to incorrect data
                showErrorToast(t('group.saveDynamicGroupResponse.400'));
                break;
            }
            case 401: {
                logout();
                break;
            }
            case 402: { // Group does not updated due to broken request
                showErrorToast(t('group.saveDynamicGroupResponse.402'));
                break;
            }
            case 404: { // Not found
                showErrorToast(t('group.saveDynamicGroupResponse.404'));
                break;
            }
            case 927: { // Tier limit reached
                setTierMessageCode(response.Message);
                setDialogType('tier');
                break;
            }
            case 500:
            default: {
                showErrorToast(t('common.Error'));
                break;
            }
        }
        setLoader(false);
    }

    const onBack = () => {
        if (pageState?.PageProperty || pageState?.PageName) {
            navigate(`${sitePrefix}Groups/Dynamic`, {
                state: {
                    from: 'editDynamicGroup'
                }
            })
        }
        else {
            sessionStorage.removeItem('PageState');
            window.history.back()
        }


    }

    const getData = async (isAfterSave?: boolean | never) => {
        setLoader(true);
        const groups = await dispatch(getById(id));
        if (groups.payload.StatusCode === 404) {
            Redirect({ url: `${sitePrefix}Groups/Dynamic`, openNewTab: false, preventRedirect: true });
            return false;
        }
        const {
            Group,
            dynamicData: {
                MyActivities, MyConditions, MyGroups
            }
        } = groups?.payload?.Data;
        setDynamicGroupModel({
            Group: Group,
            dynamicData: {
                MyActivities: MyActivities,
                MyConditions: MyConditions?.length > 0 ? MyConditions : dynamicGroupModel.dynamicData.MyConditions,
                MyGroups: MyGroups
            }
        });

        if (isAfterSave) {
            setToastMessage({ severity: 'success', color: 'success', message: t('group.saveDynamicGroupResponse.201').replace('{0}', Group?.Recipients?.toLocaleString()), showAnimtionCheck: false } as any);
        }
        setLoader(false);
    };

    useEffect(() => {
        const sessionPageState = window.sessionStorage?.getItem('PageState');
        if (sessionPageState) {
            const pState = JSON.parse(sessionPageState);
            const fromState = pState?.filter((x: any) => { return x?.PageName === 'dynamicGroups' });
            if (fromState && fromState?.length > 0) {
                setPageState(fromState[0]);
            }
        }

        getData();
    }, []);

    // PR-3790: the dynamic group's source group ids used to be matched against the
    // complete downloaded list. With the list paged, the server is asked for
    // exactly those groups instead.
    useEffect(() => {
        let cancelled = false;
        (async () => {
            const savedIds: number[] = dynamicGroupModel?.dynamicData?.MyGroups || [];
            if (savedIds.length === 0) {
                if (!cancelled) setSelectedGroups([]);
                return;
            }
            const groups = await fetchGroupsByIds(dispatch, savedIds);
            if (!cancelled) setSelectedGroups(groups as Group[]);
        })();
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dynamicGroupModel?.dynamicData?.MyGroups])

    const callbackUpdateGroups = (groups: any, event: any) => {

        if (event) {
            setSelectedGroups(groups);
            setDynamicGroupModel({
                ...dynamicGroupModel,
                dynamicData: {
                    ...dynamicGroupModel.dynamicData,
                    MyGroups: groups.map((value: Group) => value.GroupID)
                }
            });
        }
        else {
            const found = selectedGroups.map((group: Group) => { return group.GroupID; }).includes(groups.GroupID);
            const groupList: Group[] = found
                ? selectedGroups.filter((g: Group) => g.GroupID !== groups.GroupID)
                : [...selectedGroups, groups];
            setSelectedGroups(groupList);

            setDynamicGroupModel({
                ...dynamicGroupModel,
                dynamicData: {
                    ...dynamicGroupModel.dynamicData,
                    MyGroups: groupList.map((value: Group) => value.GroupID)
                }
            });
        }
    }
    // PR-3790: the browser no longer holds every group, so selecting everything
    // asks the server for the matching ids using the picker's current filter.
    const callbackSelectAll = async (filter?: PagedGroupsFilter) => {
        let groupList: Group[] = [];
        if (!allGroupsSelected) {
            const selection = await fetchGroupSelection(dispatch, filter);
            const fromServer = selection.groups;
            groupList = [...fromServer, ...(showTestGroups ? testGroups : [])] as Group[];
        }
        setSelectedGroups(groupList);
        setAllGroupsSelected(!allGroupsSelected);
        setDynamicGroupModel({
            ...dynamicGroupModel,
            dynamicData: {
                ...dynamicGroupModel.dynamicData,
                MyGroups: groupList.map((value: Group) => value.GroupID)
            }
        });
    }

    const updateMyConditions = (keyName: string, value: string) => {
        const resetCondition = ['FirstName', 'LastName', 'Email', 'Country', 'City', 'Company'];
        const reset = value === '' && resetCondition.indexOf(keyName) !== -1 ? true : false;
        setDynamicGroupModel({
            ...dynamicGroupModel, dynamicData: {
                ...dynamicGroupModel.dynamicData,
                MyConditions: [
                    {
                        ...dynamicGroupModel.dynamicData.MyConditions[0],
                        [keyName]: value,
                        ...reset && { [`${keyName}Cond`]: CondType.Undefined }
                    }
                ]
            }
        });
    }

    const updateMyActivities = (keyName: string, value: string, object: any | never = null) => {
        if (object) {
            setDynamicGroupModel({
                ...dynamicGroupModel, dynamicData: {
                    ...dynamicGroupModel.dynamicData,
                    MyActivities: {
                        ...dynamicGroupModel.dynamicData.MyActivities,
                        ...object
                    }
                }
            });
        }

        else {
            const paramsToReset = ["IsPurchased", "IsNotPurchased", "IsAbandoned", "IsPageViewed", "IsClicked", "IsNotClicked", "IsOpened", "IsNotOpened"];

            const resetValues = (keyName: string, value: string) => {
                if (paramsToReset.filter((x: string) => { return x === keyName }).length > 0 && value.toString() === 'false') {
                    switch (keyName) {
                        case 'IsClicked': {
                            setDynamicGroupModel({
                                ...dynamicGroupModel, dynamicData: {
                                    ...dynamicGroupModel.dynamicData,
                                    MyActivities: {
                                        ...dynamicGroupModel.dynamicData.MyActivities,
                                        IsClicked: null,
                                        IsClickedFromDate: null,
                                        IsClickedToDate: null,
                                        IsClickInCampaignTypes: M_AllCampaignChannelds.join(','),
                                        IsClickedInterval: ActivtyTimeInterval.Last2Weeks
                                    }
                                }
                            });
                            break;
                        }
                        case 'IsNotClicked': {
                            setDynamicGroupModel({
                                ...dynamicGroupModel, dynamicData: {
                                    ...dynamicGroupModel.dynamicData,
                                    MyActivities: {
                                        ...dynamicGroupModel.dynamicData.MyActivities,
                                        IsNotClicked: null,
                                        IsNotClickedFromDate: null,
                                        IsNotClickedToDate: null,
                                        IsNotClickInCampaignTypes: M_AllCampaignChannelds.join(','),
                                        IsNotClickedInterval: ActivtyTimeInterval.Last2Weeks
                                    }
                                }
                            });
                            break;
                        }
                        case 'IsOpened': {
                            setDynamicGroupModel({
                                ...dynamicGroupModel, dynamicData: {
                                    ...dynamicGroupModel.dynamicData,
                                    MyActivities: {
                                        ...dynamicGroupModel.dynamicData.MyActivities,
                                        IsOpened: null,
                                        IsOpenedFromDate: null,
                                        IsOpenedToDate: null,
                                        IsOpenedInterval: ActivtyTimeInterval.Last2Weeks
                                    }
                                }
                            });
                            break;
                        }
                        case 'IsNotOpened': {
                            setDynamicGroupModel({
                                ...dynamicGroupModel, dynamicData: {
                                    ...dynamicGroupModel.dynamicData,
                                    MyActivities: {
                                        ...dynamicGroupModel.dynamicData.MyActivities,
                                        IsNotOpened: null,
                                        IsNotOpenedFromDate: null,
                                        IsNotOpenedToDate: null,
                                        IsNotOpenedInterval: ActivtyTimeInterval.Last2Weeks
                                    }
                                }
                            });
                            break;
                        }
                        case 'IsPurchased': {
                            setDynamicGroupModel({
                                ...dynamicGroupModel, dynamicData: {
                                    ...dynamicGroupModel.dynamicData,
                                    MyActivities: {
                                        ...dynamicGroupModel.dynamicData.MyActivities,
                                        IsPurchased: null,
                                        IsPurchasedComparingType: ActivityEvent.Any,
                                        IsPurchasedFromDate: null,
                                        IsPurchasedToDate: null,
                                        IsPurchasedMinPrice: null,
                                        IsPurchasedMaxPrice: null,
                                        IsPurchasedInterval: ActivtyTimeInterval.Last2Weeks,
                                        PurchasedPrice: null,
                                        PurchasedProductCategory: null
                                    }
                                }
                            });
                            break;
                        }
                        case 'IsNotPurchased': {
                            setDynamicGroupModel({
                                ...dynamicGroupModel, dynamicData: {
                                    ...dynamicGroupModel.dynamicData,
                                    MyActivities: {
                                        ...dynamicGroupModel.dynamicData.MyActivities,
                                        IsNotPurchased: null,
                                        IsNotPurchasedComparingType: ActivityEvent.Any,
                                        IsNotPurchasedFromDate: null,
                                        IsNotPurchasedToDate: null,
                                        IsNotPurchasedMinPrice: null,
                                        IsNotPurchasedMaxPrice: null,
                                        IsNotPurchasedInterval: ActivtyTimeInterval.Last2Weeks,
                                        NotPurchasedPrice: null,
                                        NotPurchasedProductCategory: null
                                    }
                                }
                            });
                            break;
                        }
                        case 'IsAbandoned': {
                            setDynamicGroupModel({
                                ...dynamicGroupModel, dynamicData: {
                                    ...dynamicGroupModel.dynamicData,
                                    MyActivities: {
                                        ...dynamicGroupModel.dynamicData.MyActivities,
                                        IsAbandoned: null,
                                        IsAbandonedComparingType: ActivityEvent.Any,
                                        IsAbandonedFromDate: null,
                                        IsAbandonedToDate: null,
                                        IsAbandonedMinPrice: null,
                                        IsAbandonedMaxPrice: null,
                                        IsAbandonedInterval: ActivtyTimeInterval.Last2Weeks,
                                        AbandonedPrice: null,
                                        AbandonedProductCategory: null
                                    }
                                }
                            });
                            break;
                        }
                        case 'IsPageViewed': {
                            setDynamicGroupModel({
                                ...dynamicGroupModel, dynamicData: {
                                    ...dynamicGroupModel.dynamicData,
                                    MyActivities: {
                                        ...dynamicGroupModel.dynamicData.MyActivities,
                                        IsPageViewed: null,
                                        IsPageViewedComparingType: ActivityEvent.Any,
                                        IsPageViewedFromDate: null,
                                        IsPageViewedToDate: null,
                                        IsPageViewedMinPrice: null,
                                        IsPageViewedMaxPrice: null,
                                        IsPageViewedInterval: ActivtyTimeInterval.Last2Weeks,
                                        PageViewedPrice: null,
                                        IsPageViewedProductCategory: null,
                                        PageViewedMatchType: undefined,
                                        PageViewedContainsText: ''
                                    }
                                }
                            });
                            break;
                        }
                    }
                }
            }

            if (paramsToReset.filter((x: string) => { return x === keyName }).length > 0 && value.toString() === 'false') {
                resetValues(keyName, value);
            }
            else {
                const allCampaignTypes = M_AllCampaignChannelds?.join(',');

                setDynamicGroupModel({
                    ...dynamicGroupModel, dynamicData: {
                        ...dynamicGroupModel.dynamicData,
                        MyActivities: {
                            ...dynamicGroupModel.dynamicData.MyActivities,
                            IsClickInCampaignTypes: !dynamicGroupModel.dynamicData.MyActivities.IsClickInCampaignTypes ? allCampaignTypes : dynamicGroupModel.dynamicData.MyActivities.IsClickInCampaignTypes,
                            IsNotClickInCampaignTypes: !dynamicGroupModel.dynamicData.MyActivities.IsNotClickInCampaignTypes ? allCampaignTypes : dynamicGroupModel.dynamicData.MyActivities.IsNotClickInCampaignTypes,
                            [keyName]: value
                        }
                    }
                });
            }
        }
    }

    const updateGroup = (keyName: string, value: string) => {
        setDynamicGroupModel({
            ...dynamicGroupModel, Group: {
                ...dynamicGroupModel.Group,
                [keyName]: value
            }
        });
    }

    return (
        <DefaultScreen
            key="groups"
            currentPage='groups'
            subPage='EditDynamicGroup'
            classes={classes}
            containerClass={clsx(classes.management, classes.mb50)}
        >
            <Box className={classes.mb50}>
                <Loader isOpen={showLoader} />
                {toastMessage && renderToast()}
                <Box className={'topSection'}>
                    <Title
                        Text={dynamicGroupModel?.Group?.GroupName === '' ?
                            `${t('recipient.logPageHeaderResource1.Edit')}` :
                            `${t('recipient.logPageHeaderResource1.Edit')} - "${dynamicGroupModel?.Group?.GroupName}"`}
                        classes={classes}
                    />
                    <Box className={clsx(classes.p20)}>
                        <Tabs
                            value={tabValue}
                            onChange={(e, value) => setTabValue(value)}
                            className={clsx(classes.mr15, classes.ml15)}
                            classes={{ indicator: classes.hideIndicator }}
                        >
                            <Tab
                                label={t('common.PersonalDetails')}
                                classes={{ root: classes.tabText, selected: classes.activeTab }}
                                className={classes.iconTab}
                                value='0'
                            />
                            <Tab
                                label={t('recipient.dates')}
                                classes={{ root: classes.tabText, selected: classes.activeTab }}
                                className={classes.iconTab}
                                value='1'
                            />
                            <Tab
                                label={t('common.ActivityLevel')}
                                classes={{ root: classes.tabText, selected: classes.activeTab }}
                                className={classes.iconTab}
                                value='2'
                            />
                            <Tab
                                label={t('common.events')}
                                classes={{ root: classes.tabText, selected: classes.activeTab }}
                                className={classes.iconTab}
                                value='3'
                            />
                            <Tab
                                label={t('common.Groups')}
                                classes={{ root: classes.tabText, selected: classes.activeTab }}
                                className={classes.iconTab}
                                value='4'
                            />

                            {isYotpoConnected && (
                                <Tab
                                    label={t('appBar.groups.loyalty.title')}
                                    classes={{ root: classes.tabText, selected: classes.activeTab }}
                                    className={classes.iconTab}
                                    value='6'
                                />
                            )}

                            <Tab
                                label={t('group.updateGroup')}
                                classes={{ root: classes.tabText, selected: classes.activeTab }}
                                className={classes.iconTab}
                                value='5'
                            />
                        </Tabs>

                        <TabContext value={`${tabValue}`}>
                            <TabPanel value='0'>
                                <PersonalDetails classes={classes} data={dynamicGroupModel} onUpdate={updateMyConditions} />
                            </TabPanel>

                            <TabPanel value='1'>
                                <DateDetails classes={classes} data={dynamicGroupModel} onUpdate={updateMyConditions} />
                            </TabPanel>
                            <TabPanel value='2'>
                                <ActivityDetails classes={classes} data={dynamicGroupModel} onUpdate={updateMyActivities} />
                            </TabPanel>
                            <TabPanel value='3'>
                                <EventsDetails classes={classes} data={dynamicGroupModel} onUpdate={updateMyActivities} />
                            </TabPanel>

                            {/* Not a TabPanel: that unmounts inactive children, losing the picker's
                                loaded pages. Hidden instead; padding matches TabPanel's spacing(3). */}
                            <div
                                role='tabpanel'
                                hidden={tabValue !== '4'}
                                style={{ padding: 24, display: tabValue === '4' ? undefined : 'none' }}>
                                <div className={clsx(classes.fullWidth, classes.pt25)}>
                                    <Groups
                                        classes={classes}
                                        list={[]}
                                        fetchPage={fetchGroupsPage}
                                        pinnedRows={showTestGroups ? testGroups : []}
                                        // test={showTestGroups}
                                        selectedList={selectedGroups}
                                        callbackSelectedGroups={callbackUpdateGroups}
                                        callbackUpdateGroups={callbackUpdateGroups} //onUpdateGroups
                                        callbackSelectAll={callbackSelectAll}
                                        callbackReciFilter={() => { }} // onReciFilter
                                        callbackShowTestGroup={() => setShowTestGroups(!showTestGroups)}
                                        key={"dynuacGroups"}
                                        uniqueKey={'groups_4'}
                                        innerHeight={325}
                                        showSortBy={true}
                                        showFilter={false}
                                        showSelectAll={true}
                                        bsDot={null}
                                        isNotifications={false}
                                        isSms={true}
                                        isCampaign={false}
                                        noSelectionText={''}
                                    // isFilterSelected={false}
                                    />
                                </div>
                            </div>

                            {isYotpoConnected && (
                                <TabPanel value='6'>
                                    <LoyaltyDetails classes={classes} data={dynamicGroupModel} onUpdate={updateMyConditions} />
                                </TabPanel>
                            )}

                            <TabPanel value='5'>
                                <UpdateGroup classes={classes} data={dynamicGroupModel} onUpdate={updateGroup} />
                            </TabPanel>
                        </TabContext>
                        <Box className={clsx(classes.flex, classes.pt25)} style={{ justifyContent: 'end', marginTop: 15 }}>
                            <Button
                                onClick={onBack}
                                className={clsx(
                                    classes.btn,
                                    classes.btnRounded,
                                    classes.backButton
                                )}
                                startIcon={!isRTL ? <MdArrowBackIos /> : <MdArrowForwardIos />}
                                style={{ margin: '8px' }}
                            >
                                {t('common.back')}
                            </Button>
                            <Button
                                className={clsx(
                                    classes.btn,
                                    classes.btnRounded
                                )}
                                style={{ margin: '8px' }}
                                startIcon={<BiSave />}
                                endIcon={isRTL ? <MdArrowBackIos /> : <MdArrowForwardIos />}
                                onClick={() => { onSave(false) }}>
                                {t("common.save")}
                            </Button>
                            <Button
                                className={clsx(
                                    classes.btn,
                                    classes.btnRounded
                                )}
                                style={{ margin: '8px' }}
                                startIcon={<GiExitDoor />}
                                endIcon={isRTL ? <MdArrowBackIos /> : <MdArrowForwardIos />}
                                onClick={() => { onSave(true) }}
                            >
                                {t("common.SaveExit")}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
            {/* Tier Validation Dialog */}
			{dialogType === 'tier' && (
				<BaseDialog
					classes={classes}
					open={true}
					onCancel={() => setDialogType(null)}
					onClose={() => setDialogType(null)}
					onConfirm={() => setDialogType(null)}
					title={t('billing.tier.permission')}
					showDivider={false}
					renderButtons={() => (
                    <Grid container spacing={2} className={clsx(classes.dialogButtonsContainer, isRTL ? classes.rowReverse : null, !get(subAccount, 'CompanyAdmin', false) ? classes.dNone : '')}>
                        <Grid item>
                            <Button
                                onClick={() => {
                                    setDialogType(null);
                                    setShowTierPlans(true);
                                }}
                                className={clsx(classes.btn, classes.btnRounded)}
                            >
                                {t('billing.upgradePlan')}
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                onClick={() => { setDialogType(null); }}
                                className={clsx(classes.btn, classes.btnRounded)}
                            >
                                {t('common.cancel')}
                            </Button>
                        </Grid>
                    </Grid>
                )}
                >
					<Typography style={{ fontSize: 18 }} className={clsx(classes.textCenter)}>
						{handleGetPlanForFeature(TierMessageCode)}
					</Typography>
				</BaseDialog>
			)}
            {showTierPlans && <TierPlans
				classes={classes}
				isOpen={showTierPlans}
				onClose={() => setShowTierPlans(false)}
			/>}
        </DefaultScreen>
    )
}

export default memo(EditDynamicGroup);